
import { useDateFormat, useTimeFormat, useTimezone } from "@/utils/settings";
import { format, parseISO } from "date-fns";
import { formatInTimeZone } from "date-fns-tz";

export const formatDate = (date: string | Date | null | undefined, includeTime: boolean = false) => {
	// Return a placeholder if date is null, undefined, or invalid
	if (!date) return "Not specified";
	
	// Try to create a valid date object
	const dateObj = typeof date === 'string' ? parseISO(date) : date;
	
	// Check if date is valid before formatting
	if (isNaN(dateObj.getTime())) {
		console.error("Invalid date in formatDate:", date);
		return "Invalid date";
	}
	
	try {
		const dateFormat = useDateFormat();
		const timeFormat = useTimeFormat();
		const timezone = useTimezone();
		
		// Convert date format from settings to date-fns format
		const dateFormatMapping: { [key: string]: string } = {
			'MMM-d-yyyy': 'MMM d, yyyy',
			'MM-dd-yyyy': 'MM/dd/yyyy',
			'dd-MM-yyyy': 'dd/MM/yyyy',
			'yyyy-MM-dd': 'yyyy-MM-dd'
		};
		
		const timeFormatMapping: { [key: string]: string } = {
			'hh-mm-a': 'h:mm a',
			'HH-mm': 'HH:mm',
			'h-mm-a': 'h:mm a', 
			'HH-mm-ss': 'HH:mm:ss'
		};
		
		// Use date-fns-tz to handle timezone properly
		const formattedDate = formatInTimeZone(
			dateObj,
			timezone || 'UTC',
			dateFormatMapping[dateFormat] || 'MMM d, yyyy'
		);
		
		if (includeTime) {
			const formattedTime = formatInTimeZone(
				dateObj,
				timezone || 'UTC',
				timeFormatMapping[timeFormat] || 'h:mm a'
			);
			return `${formattedDate} ${formattedTime}`;
		}
		
		return formattedDate;
	} catch (error) {
		console.error('Error formatting date:', error, date);
		return 'Date error';
	}
};
